// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LILRa","clinicsSelect":"styles_clinicsSelect__4hDNn"};